import { render } from "./CreateConfigYmirKorea.vue?vue&type=template&id=b5da2334&scoped=true"
import script from "./CreateConfigYmirKorea.vue?vue&type=script&lang=js"
export * from "./CreateConfigYmirKorea.vue?vue&type=script&lang=js"

import "./CreateConfigYmirKorea.vue?vue&type=style&index=0&id=b5da2334&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5da2334"]])

export default __exports__